import { Component } from "@angular/core";
import { OffcanvasOptions } from "src/app/directives/home/offcanvas.directive";


@Component({
  selector: "quick-panel",
  templateUrl: "./quick-panel.component.html",
  styleUrls: ["./quick-panel.component.css"]
})
export class QuickPanelComponent {
  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: "kt-quick-panel",
    closeBy: "kt_quick_panel_close_btn",
    toggleBy: "kt_quick_panel_toggler_btn"
  };
}
